module.exports = __webpack_public_path__ + "static/media/quezishan_mobile.6a04d80b.png";